import styled from 'styled-components';

// Renders as <h1> by default so each UAM page exposes a real heading to AT.
// All call sites today render exactly one UamHeading per visible step, so
// "h1 per page" holds. If a caller ever nests UamHeadings, override with
// `<UamHeading as="h2">`.
export const UamHeading = styled.h1`
  font-family: var(--prs/ff/sans, 'Figtree', sans-serif);
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #0e0d16;
  margin: 0;

  /* Suppress focus outline on programmatic focus from step-transition handoff —
     the heading is tabIndex=-1 so it is never keyboard-tabbable, and modern
     browsers already skip the ring for non-keyboard focus. This keeps the
     visual identical to the previous <p> rendering. */
  &:focus { outline: none; }
`;

export const UamBodyText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #0e0d16;
  margin: 0;
`;

export const UamSmallText = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #0e0d16;
  margin: 0;
`;

export const UamFieldLabel = styled.label`
  display: block;
  font-size: 14px;
  line-height: 20px;
  color: #0e0d16;
  margin-bottom: 4px;
`;

export const UamTextInput = styled.input`
  width: 100%;
  border: 1px solid ${({ $error }) => ($error ? '#c00' : '#cbcacc')};
  border-radius: 3px;
  font-size: 16px;
  line-height: 24px;
  padding: 4px 16px;
  background: white;
  color: #0e0d16;
  box-sizing: border-box;

  &::placeholder {
    color: #a5a4a7;
    font-style: italic;
  }

  &:focus {
    outline: 2px solid #0600b4;
    outline-offset: 1px;
  }
`;

export const UamFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap || '0'};
  ${({ padding }) => padding && `padding: ${padding};`}
`;

export const UamLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
`;

export const UamFormSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  align-self: stretch;
`;

export const UamPageIcon = styled.img`
  width: 64px;
  height: 64px;
`;

export const UamRegistrationPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  h2 {
    font-size: 1.125rem !important;
  }
`;

export const UamErrorTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const UamErrorText = styled.p`
  color: #E0205D;
  font-size: 0.875rem;
  text-align: center;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  margin-bottom: 1.5rem;
`;
